module.exports = __webpack_public_path__ + "assets/img/icon_login_bg.7d12c581.png";